// extracted by mini-css-extract-plugin
export default {"container_home":"_home_container_home__U7Ys6"};